import React, { useState } from 'react';
import { Button, Input, Paper, FormControl, InputLabel, FormHelperText, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const UploadButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  maxWidth: '500px',
}));

const UploadForm = () => {
  const navigate = useNavigate();
  const [revenueExpensesFile, setRevenueExpensesFile] = useState(null);
  const [productDataFile, setProductDataFile] = useState(null);
  const [transactionDataFile, setTransactionDataFile] = useState(null);

  const handleRevenueExpensesFileChange = (event) => {
    setRevenueExpensesFile(event.target.files[0]);
  };

  const handleTransactionDataFileChange = (event) => {
    setTransactionDataFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!revenueExpensesFile || !productDataFile || !transactionDataFile) {
      console.error("One or more files not selected");
      return;
    }

    const formData = new FormData();
    formData.append("revenue_expenses_file", revenueExpensesFile);
    formData.append("product_data_file", productDataFile);
    formData.append("transaction_data_file", transactionDataFile); // Add the third file

    try {
      const response = await fetch(`${process.env.REACT_APP_BACK_END_URL}/analysis/scan_revenue_expenses`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        console.log("Files uploaded successfully");
        const data = await response.json();
        console.log(data); // This is the response from the server. Handle accordingly.
        navigate('/show_bizzboard', { state: { data } });
      } else {
        console.error("Failed to upload files");
      }
    } catch (error) {
      console.error("There was an error uploading the files:", error);
    }
  };

  const handleProductDataFileChange = (event) => {
    setProductDataFile(event.target.files[0]);
  };

  

  return (
    <StyledPaper elevation={3}>
      <Typography variant="h6" gutterBottom>
        Upload Your Documents
      </Typography>
      <FormControl fullWidth variant="outlined">
 
        <Input
          id="revenue-expenses-file"
          type="file"
          accept=".csv"
          onChange={handleRevenueExpensesFileChange}
          fullWidth
        />
        {revenueExpensesFile && (
          <Typography variant="body2" color="textSecondary" style={{ marginTop: '8px' }}>
            {revenueExpensesFile.name}
          </Typography>
        )}
        <FormHelperText>
          Make sure your revenue and expenses file is in CSV format.
        </FormHelperText>
      </FormControl>
      <FormControl fullWidth variant="outlined" style={{ marginTop: '16px' }}>
        <Input
          id="product-data-file"
          type="file"
          accept=".json"
          onChange={handleProductDataFileChange}
          fullWidth
        />
        {productDataFile && (
          <Typography variant="body2" color="textSecondary" style={{ marginTop: '8px' }}>
            {productDataFile.name}
          </Typography>
        )}
        <FormHelperText>
          Make sure your product data file is in JSON format.
        </FormHelperText>
        
        
      </FormControl>
      <FormControl fullWidth variant="outlined" style={{ marginTop: '16px' }}>
        <Input
          id="transaction-data-file"
          type="file"
          accept=".json"
          onChange={handleTransactionDataFileChange}
          fullWidth
        />
        {transactionDataFile && (
          <Typography variant="body2" color="textSecondary" style={{ marginTop: '8px' }}>
            {transactionDataFile.name}
          </Typography>
        )}
        <FormHelperText>
          Make sure your transaction data file is in JSON format.
        </FormHelperText>
        
        <UploadButton variant="contained" color="primary" onClick={handleSubmit}>
          Upload
        </UploadButton>
      </FormControl>
      
    </StyledPaper>
  );
};

export default UploadForm;
